import { transform, isEqual, isObject } from 'lodash'

export const isEmptyObject = (obj) => (
  (Object.keys(obj).length === 0) && (obj.constructor === Object)
)

export const removeBlankAttributesFromObject = (obj) => {
  let newObj = Object.assign({}, obj)
  Object.keys(newObj).forEach(key => (
    newObj[key] === '' || newObj[key] === null) &&
    delete newObj[key]
  )
  return newObj
}

// deep diff between two objects, using lodash
// returns new object representing the diff between object and objectToCompareWith
export const diff = (object, objectToCompareWith) => {
	return transform(object, (result, value, key) => {
		if (!isEqual(value, objectToCompareWith[key])) {
			result[key] = isObject(value) && isObject(objectToCompareWith[key])
        ? diff(value, objectToCompareWith[key])
        : value
		}
	})
}



// WEBPACK FOOTER //
// ./src/utils/object/index.js